import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Box,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { CATEGORIES, MESSAGE_TYPES, SEVERITY_LEVELS } from "./utils";

export default function TemplateDialog({
  open,
  onClose,
  currentTemplate,
  templateForm,
  setTemplateForm,
  onSave,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        {currentTemplate ? "Edit Template" : "Create Template"}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <TextField
            fullWidth
            label="Template Name"
            value={templateForm.name}
            onChange={(e) =>
              setTemplateForm({ ...templateForm, name: e.target.value })
            }
            sx={{ mb: 2 }}
          />

          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Category</InputLabel>
            <Select
              value={templateForm.category}
              label="Category"
              onChange={(e) =>
                setTemplateForm({ ...templateForm, category: e.target.value })
              }
            >
              {CATEGORIES.map((cat) => (
                <MenuItem key={cat.value} value={cat.value}>
                  {cat.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Type</InputLabel>
                <Select
                  value={templateForm.type}
                  label="Type"
                  onChange={(e) =>
                    setTemplateForm({ ...templateForm, type: e.target.value })
                  }
                >
                  {MESSAGE_TYPES.map((type) => (
                    <MenuItem key={type.value} value={type.value}>
                      {type.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Severity</InputLabel>
                <Select
                  value={templateForm.severity}
                  label="Severity"
                  onChange={(e) =>
                    setTemplateForm({ ...templateForm, severity: e.target.value })
                  }
                >
                  {SEVERITY_LEVELS.map((level) => (
                    <MenuItem key={level.value} value={level.value}>
                      {level.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <TextField
            fullWidth
            label="Message Title"
            value={templateForm.title}
            onChange={(e) =>
              setTemplateForm({ ...templateForm, title: e.target.value })
            }
            sx={{ mb: 2 }}
          />

          <TextField
            fullWidth
            label="Message Content"
            multiline
            rows={4}
            value={templateForm.message}
            onChange={(e) =>
              setTemplateForm({ ...templateForm, message: e.target.value })
            }
            sx={{ mb: 2 }}
          />

          <TextField
            fullWidth
            label="Variables (comma-separated)"
            placeholder="e.g., username, email, date"
            value={templateForm.variables.join(", ")}
            onChange={(e) =>
              setTemplateForm({
                ...templateForm,
                variables: e.target.value
                  .split(",")
                  .map((v) => v.trim())
                  .filter(Boolean),
              })
            }
            helperText="Variables that can be used in the template message"
            sx={{ mb: 2 }}
          />

          <FormControlLabel
            control={
              <Switch
                checked={templateForm.isActive}
                onChange={(e) =>
                  setTemplateForm({ ...templateForm, isActive: e.target.checked })
                }
              />
            }
            label="Active"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onSave} variant="contained">
          {currentTemplate ? "Update" : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
